// WEST-989: a county's products are a comma-separated list of codes in customer.products:
// tax (Web Tax), doc (Web Doc), tpay (Web Pay). disable_list uses the same codes to switch one
// off temporarily (the page then shows customer.disable_message).
const codes = (value) =>
  typeof value === 'string'
    ? value.split(',').map((c) => c.trim().toLowerCase()).filter(Boolean)
    : [];

export const hasProduct = (dataClient, code) => codes(dataClient?.products).includes(code);

export const isProductDisabled = (dataClient, code) =>
  codes(dataClient?.disable_list).includes(code);
